<template>
  <OrganismModal
    v-model:is-shown="isModalOpened"
    :title="t(`dashboard.explanationsModal.${sectionKey}.title`)"
    :has-backdrop-clickable="true"
    size="sm"
    @cancel="emit('update:isConditionsModalOpen', false)"
  >
    <div class="mx-2" data-cy="dashboard-key-indicator-modal">
      <AtomText
        class="mb-2"
        :text="t(`dashboard.explanationsModal.${sectionKey}.description`)"
        font-size="text-sm"
        font-style="font-medium"
        color-variant="description"
        data-cy="dashboard-key-indicator-modal-description"
      />

      <AtomText
        class="mb-2"
        :text="t('dashboard.explanationsModal.subtitleOne')"
        font-style="font-semibold"
        data-cy="dashboard-key-indicator-modal-subtitle-one"
      />

      <AtomText
        class="mb-2"
        :text="t(`dashboard.explanationsModal.${sectionKey}.paragraphOne`)"
        font-size="text-sm"
        font-style="font-medium"
        color-variant="description"
        data-cy="dashboard-key-indicator-modal-paragraph-one"
      />

      <AtomText
        class="mb-2"
        :text="t('dashboard.explanationsModal.subtitleTwo')"
        font-style="font-semibold"
        data-cy="dashboard-key-indicator-modal-subtitle-two"
      />

      <AtomText
        class="mb-2"
        :text="t(`dashboard.explanationsModal.${sectionKey}.paragraphTwo`)"
        font-size="text-sm"
        font-style="font-medium"
        color-variant="description"
        data-cy="dashboard-key-indicator-modal-paragraph-two"
      />
    </div>

    <template #footer="{ cancel }">
      <div class="flex">
        <MoleculeButton
          :label="t('commons.close')"
          variant="primary"
          expanded
          data-cy="dashboard-key-indicator-modal-close-button"
          @clicked="cancel"
        />
      </div>
    </template>
  </OrganismModal>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

type IExplanationModalProps = {
  isModalVisible: boolean;
  sectionKey: 'failures' | 'activationDeadline' | 'averageEquipmentsInstalled';
};

const props = defineProps<IExplanationModalProps>();
const emit = defineEmits(['update:isConditionsModalOpen']);

const { t } = useI18n();

const isModalOpened = computed({
  get: () => props.isModalVisible,
  set: (newState: boolean) => {
    emit('update:isConditionsModalOpen', newState);
  },
});
</script>
